<ng-container *ngIf="canSeeAssistant">

  <!-- Burbuja: punto de entrada al asistente. Vive fija en la esquina inferior derecha -->
  <!-- Si Bryant sigue respondiendo con el panel cerrado, o ya respondió, la burbuja lo avisa -->
  <button *ngIf="!isOpen && !isOnChatPage" type="button" class="bl-dock-fab" (click)="open()"
    [class.is-busy]="isBusy" [class.has-unread]="hasUnread && !isBusy"
    [attr.aria-label]="isBusy ? ('BELIVPEDIA.MESSAGES.BIX_RESPONDING' | translate)
      : hasUnread ? ('BELIVPEDIA.MESSAGES.BIX_ANSWER_READY' | translate)
      : label('Abrir Bryant', 'Open Bryant')"
    [ngbTooltip]="isBusy ? ('BELIVPEDIA.MESSAGES.BIX_RESPONDING' | translate)
      : hasUnread ? ('BELIVPEDIA.MESSAGES.BIX_ANSWER_READY' | translate)
      : label('Pregúntale a Bryant', 'Ask Bryant')" placement="left" container="body">
    <span class="bl-dock-fab-pulse" aria-hidden="true"></span>
    <img class="bl-dock-fab-avatar" [src]="bixAvatar" alt="Bryant" />

    <span *ngIf="isBusy" class="bl-dock-fab-typing" aria-hidden="true">
      <i></i><i></i><i></i>
    </span>
    <span *ngIf="hasUnread && !isBusy" class="bl-dock-fab-badge" aria-hidden="true"></span>
    <span *ngIf="!isBusy && !hasUnread" class="bl-dock-fab-dot" aria-hidden="true"></span>
  </button>

  <!-- Velo: solo se ve en móvil, donde el panel ocupa toda la pantalla -->
  <div class="bl-dock-backdrop" *ngIf="isOpen" (click)="close()"></div>

  <!-- Panel acoplado -->
  <aside class="bl-dock-panel" *ngIf="isOpen" [style.width.vw]="width"
    [class.is-resizing]="isResizing" role="complementary"
    [attr.aria-label]="label('Asistente Bryant', 'Bryant assistant')">

    <!-- Borde arrastrable: define cuánto de la pantalla ocupa el chat -->
    <div class="bl-dock-grip" (mousedown)="startResize($event)" (touchstart)="startResize($event)"
      (dblclick)="resetWidth()" [ngbTooltip]="label('Arrastra para ajustar · doble clic para restablecer', 'Drag to resize · double-click to reset')"
      placement="left" container="body">
      <span class="bl-dock-grip-bar" aria-hidden="true"></span>
    </div>

    <app-chat-content variant="dock" [isFloating]="true"></app-chat-content>
  </aside>

</ng-container>
